export const BUTTON_FILTER_MACHINE_UPDATE = "button-filter-machine-update"
export const BUTTON_ADD_MACHINE_UPDATE = "button-add-machine-update"
export const BUTTON_UPDATE_MACHINE_UPDATE = "button-update-machine-update"

// Module User
export const BUTTON_UPDATE_USER_UPDATE = "button-update-user-update";
export const BUTTON_ADD_USER_UPDATE = "button-add-user-update";
export const BUTTON_EXPORT_USER_SEARCH = 'button-export-user-search';
export const BUTTON_SEARCH_USER = 'button-search-user';

// Module Inspection
export const BUTTON_SEARCH_MACHINE_INPUT = "button-search-machine-input";
export const BUTTON_REGISTER_INSPECTION  = "button-register-inspection";
export const BUTTON_REGISTER_TEMPORARY_INSPECTION  = "button-register-temporary-inspection";
export const BUTTON_SET_TEMPORARY_INSPECTION  = "button-set-temporary-inspection";
export const BUTTON_UPDATE_INSPECTION  = "button-update-inspection";

// Module Search
export const BUTTON_NEXT_INSPECTION_CONFIRM = "button-next-inspection-confirm";
export const BUTTON_EXPORT_INSPECTION_CONFIRM = "button-export-inspection-confirm";
export const BUTTON_REGISTER_INSPECTION_CORRECTION = "button-register-inspection-correction";
export const BUTTON_CANCEL_INSPECTION = "button-cancel-inspection-confirm";


// Module Treatment
export const BUTTON_REGISTER_TREATMENT = "button-register-treatment";


